var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3247_7957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 6.66666C8.15801 6.66666 6.66634 8.15833 6.66634 10C6.66634 11.8417 8.15801 13.3333 9.99967 13.3333C11.8413 13.3333 13.333 11.8417 13.333 10C13.333 8.15833 11.8413 6.66666 9.99967 6.66666ZM17.4497 9.16666C17.2609 7.47676 16.5031 5.90128 15.3008 4.69891C14.0984 3.49654 12.5229 2.73875 10.833 2.54999V1.66666C10.833 1.20833 10.458 0.833328 9.99967 0.833328C9.54134 0.833328 9.16634 1.20833 9.16634 1.66666V2.54999C7.47644 2.73875 5.90096 3.49654 4.69859 4.69891C3.49622 5.90128 2.73843 7.47676 2.54967 9.16666H1.66634C1.20801 9.16666 0.833008 9.54166 0.833008 10C0.833008 10.4583 1.20801 10.8333 1.66634 10.8333H2.54967C2.73843 12.5232 3.49622 14.0987 4.69859 15.3011C5.90096 16.5035 7.47644 17.2612 9.16634 17.45V18.3333C9.16634 18.7917 9.54134 19.1667 9.99967 19.1667C10.458 19.1667 10.833 18.7917 10.833 18.3333V17.45C12.5229 17.2612 14.0984 16.5035 15.3008 15.3011C16.5031 14.0987 17.2609 12.5232 17.4497 10.8333H18.333C18.7913 10.8333 19.1663 10.4583 19.1663 10C19.1663 9.54166 18.7913 9.16666 18.333 9.16666H17.4497ZM9.99967 15.8333C6.77467 15.8333 4.16634 13.225 4.16634 10C4.16634 6.775 6.77467 4.16666 9.99967 4.16666C13.2247 4.16666 15.833 6.775 15.833 10C15.833 13.225 13.2247 15.8333 9.99967 15.8333Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3247_7957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f477946113149a9393b01332dfa5d271.svg";
export { ForwardRef as ReactComponent };